import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './NewsletterDetail.css';
import { loadNewsletterContent, newslettersMeta } from '../../newsletters.data.js';
import NewsletterSubscribe from '../../components/es/NewsletterSubscribe';
import { useAuth } from '../../context/AuthContext.jsx'; // 1. Importamos tu hook de autenticación

const cleanEmailHtml = (rawHtml) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(rawHtml, 'text/html');
  const greetingElement = Array.from(doc.querySelectorAll('h2, p')).find(el => el.textContent.includes('Hola {{nombre}}'));
  if (greetingElement) greetingElement.remove();
  const mainContentNode = doc.querySelector('td[style*="padding: 40px 30px"]');
  if (!mainContentNode) return doc.body ? doc.body.innerHTML : '';
  const allElements = mainContentNode.querySelectorAll('*');
  allElements.forEach(el => {
    el.removeAttribute('style');
    el.removeAttribute('color');
    el.removeAttribute('bgcolor');
    el.removeAttribute('align');
    el.removeAttribute('width');
    el.removeAttribute('height');
    el.removeAttribute('border');
    el.removeAttribute('cellpadding');
    el.removeAttribute('cellspacing');
    el.classList.remove('fallback-font');
  });
  return mainContentNode.innerHTML;
};

const NewsletterDetail = () => {
    const { campaign, slug } = useParams();
    const { loggedIn } = useAuth(); // 2. Obtenemos el estado de autenticación
    const [content, setContent] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const meta = newslettersMeta.find(p => p.campaign === campaign && p.slug === slug);

    useEffect(() => {
        setIsLoading(true);
        setContent('');
        setError(null);
        
        loadNewsletterContent(campaign, slug)
            .then(module => {
                const cleanedHtml = cleanEmailHtml(module.default);
                setContent(cleanedHtml);
            })
            .catch(err => {
                console.error("Error cargando el newsletter:", err);
                setError("No se pudo cargar el contenido del newsletter.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [campaign, slug]);

    if (!meta) {
        return <div className="text-center py-20 text-red-400">Newsletter no encontrado.</div>;
    }

    return (
        <div className="bg-gray-900 text-white min-h-screen font-sans">
            <header className="py-6 container mx-auto px-6">
                <Link to="/newsletter" className="text-emerald-400 hover:text-emerald-300">
                    &larr; Volver al Archivo
                </Link>
            </header>
            <main className="container mx-auto px-6 pb-20">
                <article className="max-w-2xl mx-auto">
                    <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">{meta.title}</h1>
                    {isLoading && <p className="text-gray-400">Cargando...</p>}
                    {error && <p className="text-red-400">{error}</p>}
                    <div 
                        className="newsletter-content"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </article>

                {/* 3. Renderizado Condicional del Formulario */}
                {/* Si el usuario NO está logueado, muestra el formulario */}
                {!loggedIn && (
                    <div className="max-w-2xl mx-auto mt-16 pt-12 border-t border-gray-700">
                        <NewsletterSubscribe />
                    </div>
                )}
            </main>
        </div>
    );
};

export default NewsletterDetail;